import { storeToRefs } from "pinia";
import { useTasksStore } from "@/stores/v2";
import { isVaccinationTask } from "@/stores/v2/sites/utils";
import { WeightRecord, VaccinationProgressEntry } from "@/types/v2";
import { useWeight } from "@/composables/tasks/vaccination/useVaccinationWeight";

export function useVaccinationProgress() {
  // ===================================================================
  // Store
  // ===================================================================
  const { activeTask } = storeToRefs(useTasksStore());
  const { isIndividualWeightType } = useWeight();

  // ===================================================================
  // GETTERS
  // ===================================================================
  // Get Configuration Vaccination Progress
  const getConfigurationVaccinationProgress = (configKey: string): number => {
    if (!activeTask.value || !isVaccinationTask(activeTask.value)) return 0;

    const configuration = activeTask.value.details.configurations.find(
      (config) => config.key === configKey
    );
    if (!configuration) return 0;

    return (
      configuration.progressData?.reduce(
        (sum: number, item: VaccinationProgressEntry) => sum + (item.vaccinated || 0),
        0
      ) || 0
    );
  };

  // Get Configuration Weight Progress
  const getConfigurationWeightProgress = (configurationKey: string): number => {
    if (!activeTask.value || !isVaccinationTask(activeTask.value) || !isIndividualWeightType.value) return 0;

    if (!activeTask.value.details.weightConfiguration.progressData) {
      activeTask.value.details.weightConfiguration.progressData = [];
    }

    return activeTask.value.details.weightConfiguration.progressData
      .filter((record: WeightRecord) => record.configurationKey === configurationKey).length;
  };

  return {
    getConfigurationVaccinationProgress,
    getConfigurationWeightProgress,
  };
}